export const saveUnselectedColumns = (columns: string[], SAVED_HIDDEN_COLUMNS_KEY: string) => {
  localStorage.setItem(SAVED_HIDDEN_COLUMNS_KEY, JSON.stringify(columns));
};

export const saveColumnsOrder = (columns: string[], SAVED_COLUMNS_ORDER_KEY: string) => {
  localStorage.setItem(SAVED_COLUMNS_ORDER_KEY, JSON.stringify(columns));
};

export const populateIsVisibleColumnsFlag = (columns: any[], SAVED_HIDDEN_COLUMNS_KEY: string) => {
  const savedHiddenColumnsRaw = localStorage.getItem(SAVED_HIDDEN_COLUMNS_KEY);
  if (savedHiddenColumnsRaw) {
    const savedHiddenColumns: string[] = JSON.parse(savedHiddenColumnsRaw);
    columns.forEach(column => {
      column.isVisible = !savedHiddenColumns.map(x => x.toLowerCase()).includes(column.key.toLowerCase());
    });
  }
};

export const adjustColumns = (data: any, skippedColumns?: string[], filters: Record<string, React.Key[] | null> | null = null) => {
  const columns = data.columns.filter((x: ColumnProps) => x.key !== 'actions');

  let allVisibleColumns = data.columns
    .filter((x: ColumnProps) => (skippedColumns && !skippedColumns.includes(x.key)) || !skippedColumns)
    .filter((x: ColumnProps) => x.isVisible);

  //apply saved filters
  allVisibleColumns = allVisibleColumns.map((x: any) => {
    if (filters && filters[x.dataIndex]) return { ...x, filteredValue: filters[x.dataIndex] };
    else return x;
  });

  return { columns, allVisibleColumns };
};

export const getColumns = (
  key: string,
  title: string,
  addDataIndex = true,
  getColumnWidth: (key: string) => string,
  render?: ((record: string) => JSX.Element) | undefined,
  isVisible?: boolean
) => ({
  key: key,
  title,
  dataIndex: addDataIndex ? key : undefined,
  width: getColumnWidth(key),
  render,
  isVisible
});

export const generateColumn = (
  key: string,
  title: string,
  addDataIndex: boolean,
  render: ((record: string) => JSX.Element) | undefined,
  isVisible: boolean
) => {
  return {
    key: key,
    title: title,
    addDataIndex,
    render: render,
    isVisible
  };
};

export type Column = {
  key: string;
  title: string;
  addDataIndex: boolean;
  render?: ((record: string) => JSX.Element) | undefined;
  isVisible: boolean;
};

export type ColumnProps = {
  title: string;
  dataIndex?: string;
  key: string;
  render?: (annotation: any) => JSX.Element;
  width?: string;
  isVisible?: boolean;
};

export const getStorageData = (savedKey: string) => {
  const unparsedData = localStorage.getItem(savedKey);
  if (unparsedData) {
    const parsedData = JSON.parse(unparsedData);
    return parsedData.length;
  }
  return 0;
};
